import TeeSelector from './TeeSelector'

export default TeeSelector
